import { tz } from '@date-fns/tz';
import { format, parseISO } from 'date-fns';
import type { ServiceReservation } from '../apiHelpers';

/**
 * Time shown on occupant list cards. When the guest is seated at a table and we
 * have seating rows with {@link Seating.createdAt}, uses the most recent seated
 * instant in the restaurant timezone (e.g. after a seat change); otherwise the
 * reservation's booked time.
 */
export const getReservationCardDisplayIsoTime = (
  reservation: ServiceReservation,
  timezone: string,
): string => {
  if (!reservation.seatedTableName) {
    return reservation.time;
  }

  const dates = reservation.seatings
    .map((s) => s.createdAt)
    .filter((v): v is string => Boolean(v))
    .map((createdAt) => parseISO(createdAt));

  if (!dates.length) {
    return reservation.time;
  }

  const mostRecent = dates.reduce((a, b) =>
    a.getTime() >= b.getTime() ? a : b,
  );

  return format(mostRecent, 'HH:mm:ss', { in: tz(timezone) });
};
